import { FontColorEnum, FormField, FormHint, FormLabel } from '@acceso/design-system';
import { Controller, FieldValues, Path, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { FilesPicker } from '../FilesPicker/FilesPicker';

type TInputFileProps<T extends FieldValues> = {
  form: UseFormReturn<T>;
  name: Path<T>;
  label: string;
  required?: boolean;
  disabled?: boolean;
  format: string;
  maxSize: number;
  accept?: string;
};

export function InputFile<T extends FieldValues>({
  form,
  name,
  required,
  disabled,
  label,
  format,
  maxSize,
  accept,
}: TInputFileProps<T>) {
  const { t } = useTranslation();
  const { control } = form;
  const labelSuffix = required ? '*' : '';

  return (
    <FormField>
      {label && (
        <FormLabel htmlFor={name}>
          {label}
          {labelSuffix}
        </FormLabel>
      )}
      <Controller
        disabled={disabled}
        name={name}
        control={control}
        rules={{
          required: required ? { value: true, message: t('El campo es obligatorio') } : false,
        }}
        render={({ field: { value, onChange }, fieldState: { error } }) => {
          return (
            <>
              <FilesPicker
                singleFile
                value={value}
                onChange={files => {
                  onChange(files[0]);
                }}
                format={format}
                maxSize={maxSize}
                accept={accept}
              />

              {error && (
                <FormHint color={FontColorEnum.Error20} type="error">
                  {error.message}
                </FormHint>
              )}
            </>
          );
        }}
      />
    </FormField>
  );
}
